import { useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/Input";
import { Button } from "@/components/ui/Button";
import { formatBytes } from "@/lib/format";

interface SharedFile { file: { name: string; mime: string; size_bytes: number }; download_url: string; expires_at: number; guest_message?: string | null; }
export function GuestFilePage() {
  const { token } = useParams();
  return <GuestFileContent key={token} token={token} />;
}
function GuestFileContent({ token }: { token?: string }) {
  const [password, setPassword] = useState("");
  const [file, setFile] = useState<SharedFile | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const resolve = async () => {
    if (!token) return; setBusy(true); setError(null); setFile(null);
    try { setFile(await api<SharedFile>(`/v1/public/shares/${encodeURIComponent(token)}/resolve`, { anonymous: true, method: "POST", body: JSON.stringify({ password: password || undefined }) })); }
    catch (e) { setError(e instanceof Error ? e.message : String(e)); }
    finally { setBusy(false); }
  };
  return <main className="min-h-screen grid place-items-center bg-surface-base p-5"><section className="w-full max-w-lg rounded border bg-canvas p-6 space-y-4">
    <h1 className="text-xl font-bold">共有ファイル</h1>
    <p className="text-sm text-fg-secondary">エールチャットから共有されたファイルをダウンロードできます。</p>
    {error && <p role="alert" className="text-danger">{error}</p>}
    {file ? <><h2 className="font-semibold break-all">{file.file.name}</h2><p>{formatBytes(file.file.size_bytes)} · {file.file.mime}</p>{file.guest_message && <p className="whitespace-pre-wrap">{file.guest_message}</p>}
      <a className="inline-block rounded bg-brand-600 text-white px-4 py-2" href={file.download_url} download={file.file.name} rel="noopener noreferrer">ダウンロード</a>
      <p className="text-xs text-fg-muted">ダウンロード URL の有効期限: {new Date(file.expires_at).toLocaleString()}</p>
      <Button variant="ghost" size="sm" disabled={busy} onClick={() => void resolve()}>リンクを再取得</Button></> : <form onSubmit={e => { e.preventDefault(); void resolve(); }} className="space-y-4">
      <label className="block text-sm space-y-2"><span>共有パスワード（設定されている場合）</span><Input type="password" value={password} onChange={e => setPassword(e.target.value)} autoComplete="off" /></label>
      <Button type="submit" disabled={busy || !token}>{busy ? "確認しています…" : "ダウンロードリンクを取得"}</Button>
    </form>}
  </section></main>;
}
